import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function Q1Conclusion() {
  const { lightColor, darkColor, primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
    highlight: {
      color: `${primaryColor} !important`,
      fontWeight: 'bold',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            What does the data say?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <Typography variant="h5" gutterBottom>Can families afford child care?</Typography>
                <Typography variant="body1">
                  Child care is <span style={{ color: primaryColor, fontWeight: 'bold' }}>not affordable</span> for working families across the country.

                  Paying for child care is a <span style={{ color: primaryColor, fontWeight: 'bold' }}>huge financial burden</span> for certain groups, including single-parent families.
                </Typography>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q1Conclusion;
